module.exports = __webpack_public_path__ + "static/media/detail.2855d0c2.svg";